import { useState } from "react";
import { PageHeader } from "@/components/ui-kit";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, CalendarClock, Repeat } from "lucide-react";
import CalendarView from "@/components/calendar/CalendarView";
import { EventForm } from "@/components/calendar/EventForm";
import { ClassOccurrenceDialog } from "@/components/calendar/ClassOccurrenceDialog";
import { DeadlineDialog } from "@/components/calendar/DeadlineDialog";
import { SeriesManager } from "@/components/calendar/SeriesManager";
import { PROGRAM_LABELS, todayMelb } from "@/lib/calendar";

export default function TutorCalendar() {
  const [program, setProgram] = useState("all");
  const [refresh, setRefresh] = useState(0);
  const [eventForm, setEventForm] = useState(null);
  const [occ, setOcc] = useState(null);
  const [deadline, setDeadline] = useState(null);
  const [seriesOpen, setSeriesOpen] = useState(false);
  const bump = () => setRefresh((n) => n + 1);
  const saved = () => { setEventForm(null); setOcc(null); setDeadline(null); bump(); };

  const onEvent = (ev) => {
    if (ev.type === "deadline") setDeadline({ homework_id: ev.homework_id, date: ev.date });
    else if (ev.series_id) setOcc(ev);
    else setEventForm(ev);
  };

  return (
    <div className="animate-fade-up" data-testid="tutor-calendar-page">
      <PageHeader title="Calendar" subtitle="Classes, mock exams, deadlines and key dates. Click any day to add an event, or any event to edit it."
        right={
          <div className="flex flex-wrap items-center gap-2">
            <Select value={program} onValueChange={setProgram}>
              <SelectTrigger data-testid="calendar-program-filter" className="h-10 w-48 rounded-xl"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="all">All programs</SelectItem>{Object.entries(PROGRAM_LABELS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
            </Select>
            <Button variant="outline" onClick={() => setSeriesOpen(true)} data-testid="manage-series-btn" className="h-10 rounded-xl font-bold"><Repeat className="mr-1.5 h-4 w-4" /> Class schedule</Button>
            <Button variant="outline" onClick={() => setDeadline({ date: todayMelb() })} data-testid="add-deadline-btn" className="h-10 rounded-xl font-bold"><CalendarClock className="mr-1.5 h-4 w-4" /> Homework deadline</Button>
            <Button onClick={() => setEventForm({ date: todayMelb() })} data-testid="add-event-btn" className="h-10 rounded-xl ember-gradient font-bold"><Plus className="mr-1.5 h-4 w-4" /> Add event</Button>
          </div>
        } />
      <CalendarView program={program === "all" ? null : program} refreshKey={refresh} onEventClick={onEvent}
        onDayClick={(ds) => setEventForm({ date: ds, programs: program === "all" ? [] : [program] })} />
      <EventForm initial={eventForm} onClose={() => setEventForm(null)} onSaved={saved} />
      <ClassOccurrenceDialog ev={occ} onClose={() => setOcc(null)} onSaved={saved} />
      <DeadlineDialog initial={deadline} onClose={() => setDeadline(null)} onSaved={saved} />
      <SeriesManager open={seriesOpen} onClose={() => setSeriesOpen(false)} onChanged={bump} />
    </div>
  );
}
